import React from 'react';
import TopNav from 'components/TopNav';

import './TopNavLayout.scss';

const TopNavLayout = props => {
	const { children, className } = props;
	return (
		<div className={`TopNavLayout ${className}`}>
			<TopNav />
			<div className="layout-body">{children}</div>
		</div>
	);
};

export default TopNavLayout;
